<template>
  <div class="card modal-card is-min-width-800">
    <header class="bandeau-modal card-header">
    </header>
    <div class="modal-card-body">
      <echeancePaiementsTable :commande="ligne" :showTypePiece="true"
        class="VueTables__table table is-bordered is-fullwidth is-striped" />
    </div>
  </div>
</template>

<script>
import echeancePaiementsTable from '@/components/baux/contrat/echeancesContratTooltipTable/echeancePaiementsTable';

export default {
  name: 'PopupPaiementEcheancierContrat',
  props: {
    ligne: {
      type: Object,
      required: true,
    },
  },
  components: {
    echeancePaiementsTable,
  },
};
</script>

<style scoped>

</style>
